import { IArticleDto } from '../../api/ClientApi';
import { RootState } from '../reducers';

export function getArticle(state: RootState): IArticleDto | null {
    return state.article.article;
}

//***************************** All Articles Selectors *****************************/
export function getAllArticles(state: RootState): IArticleDto[] | null {
    return state.articles.articles;
}

export function getArticleById(articleId: number): (state: RootState) => IArticleDto {
    return function (state: RootState): IArticleDto {
        if (!state.articles.articles) {
            throw Error();
        }

        const res = state.articles.articles.find((article: IArticleDto) => article.id === articleId);
        if (!res) {
            throw new Error();
        }

        return res;
    };
}
